<template>
  <v-dialog fullscreen transition="slide-x-transition" v-model="modal">
    <div class="expande-horizontal expande-vertical-vh vitrify centraliza">
      <v-flex xs12 md10>
        <div class="animate__animated expande-horizontal column">
          <div class="expande-horizontal centraliza wrap py-6 pb-0">
            <v-flex xs12 md8>
              <div class="expande-horizontal wrap">
                <v-card
                  color=""
                  class="expande-horizontal"
                  style="min-height: 77vh;"
                >
                  <div class="expande-horizontal">
                    <!-- <v-flex
                      v-if="$vuetify.breakpoint.smAndUp"
                      class="pa-6"
                      xs12
                      md6
                    > -->
                    <v-flex
                      v-if="false"
                      class="pa-6"
                      xs12
                      md6
                    >
                      <div
                        style="min-height: 60vh;"
                        class="expande-horizontal pa-6 centraliza"
                      >
                        <LottieAnimation
                          v-if="loading === 'loading_rocket'"
                          class="pa-6"
                          ref="anim"
                          :loop="true"
                          :animationData="
                            require('@/apps/shared/assets/loading_rocket.json')
                          "
                        />
                        <LottieAnimation
                          v-if="loading === 'success'"
                          class="pa-6"
                          ref="anim2"
                          :animationData="
                            require('@/apps/shared/assets/activate_account_success.json')
                          "
                        />
                        <LottieAnimation
                          v-if="loading === 'man_typing'"
                          :loop="true"
                          class="pa-6 animate__fadeInUp"
                          ref="anim3"
                          :animationData="
                            require('@/apps/shared/assets/expense.json')
                          "
                        />
                      </div>
                    </v-flex>
                    <v-flex class="pa-6" xs12 md12>
                      <v-window v-model="step">
                        <v-window-item :value="1">
                          <div
                            style="min-height: 57vh;"
                            transition="fade"
                            class="pt-6 mt-3 expande-horizontal centraliza fonte animate__fadeInLeft animate__delay-2s wrap"
                          >
                            <v-flex class="pa-5 pb-2" xs12>
                              <div
                                class="expande-horizontal column animate__fadeIn"
                              >
                                <h1 class="fonte" style="color: #1173ff;">
                                  {{
                                    $helper.formataSaldo(
                                      parseFloat(
                                        get_gestordepedido.compra.preco_total
                                      ) -
                                        (get_gestordepedido.compra
                                          .total_recebido || 0)
                                    )
                                  }}
                                </h1>
                                <span class="fonte grey--text"
                                  >Escolha a forma de pagamento...</span
                                >
                              </div>
                            </v-flex>
                            <v-flex class="pa-3" xs12>
                              <v-flex xs12 class="">
                                <v-list
                                  v-if="loading === 'man_typing'"
                                  nav
                                  two-line
                                  class="animate__fadeInRight animate__animated pa-0 ma-0 pb-6"
                                >
                                  <v-list-item
                                    :class="
                                      indexByArrow === 0
                                        ? 'paymentMethodPreSelected'
                                        : ''
                                    "
                                    @click="selectPaymentMethod('dinheiro')"
                                  >
                                    <v-icon
                                      class="mr-3 ml-3"
                                      size="21"
                                      color="green"
                                      >mdi-cash</v-icon
                                    >
                                    <v-list-item-content>
                                      <v-list-item-subtitle
                                        class="fonte fonte-mini fonte-bold font-default-color"
                                      >
                                        1 Dinheiro
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item
                                    v-if="false"
                                    :class="
                                      indexByArrow === 1
                                        ? 'paymentMethodPreSelected'
                                        : ''
                                    "
                                    @click="selectPaymentMethod('pix')"
                                  >
                                    <v-icon
                                      class="mr-3 ml-3"
                                      size="21"
                                      color="green"
                                      >mdi-cash</v-icon
                                    >
                                    <v-list-item-content>
                                      <v-list-item-subtitle
                                        class="fonte fonte-mini fonte-bold font-default-color"
                                      >
                                        2 Pix
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item
                                    v-if="false"
                                    :class="
                                      indexByArrow === 2
                                        ? 'paymentMethodPreSelected'
                                        : ''
                                    "
                                    @click="selectPaymentMethod('credito')"
                                  >
                                    <v-icon
                                      class="mr-3 ml-3"
                                      size="21"
                                      color="green"
                                      >mdi-credit-card</v-icon
                                    >
                                    <v-list-item-content>
                                      <v-list-item-subtitle
                                        class="fonte fonte-mini fonte-bold font-default-color"
                                      >
                                        3 Crédito
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item
                                    v-if="false"
                                    :class="
                                      indexByArrow === 3
                                        ? 'paymentMethodPreSelected'
                                        : ''
                                    "
                                    @click="selectPaymentMethod('debito')"
                                  >
                                    <v-icon
                                      class="mr-3 ml-3"
                                      size="21"
                                      color="green"
                                      >mdi-credit-card</v-icon
                                    >
                                    <v-list-item-content>
                                      <v-list-item-subtitle
                                        class="fonte fonte-mini fonte-bold font-default-color"
                                      >
                                        4 Débito
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item
                                    v-for="(method, customIndex) in customPaymentMethods"
                                    :key="method.key"
                                    :class="
                                      indexByArrow === customIndex + 1
                                        ? 'paymentMethodPreSelected'
                                        : ''
                                    "
                                    @click="selectPaymentMethod(method)"
                                  >
                                    <v-icon
                                      class="mr-3 ml-3"
                                      size="21"
                                      color="green"
                                      >{{ method.icon }}</v-icon
                                    >
                                    <v-list-item-content>
                                      <v-list-item-subtitle
                                        class="fonte fonte-mini fonte-bold font-default-color"
                                      >
                                        {{ customIndex + 2 }} {{ method.label }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                <v-btn
                                  @click="close"
                                  dark
                                  text
                                  class="fonte animate__delay-2s animate__fadeIn grey--text text-capitalize mt-6"
                                  >Fechar
                                  <v-icon size="16" class="mt-1" color="grey"
                                    >mdi-close</v-icon
                                  >
                                </v-btn>
                              </v-flex>
                            </v-flex>
                          </div>
                        </v-window-item>
                        <v-window-item :value="2">
                          <div
                            transition="fade"
                            v-if="loading === 'man_typing'"
                            style="min-height: 57vh;"
                            class="mt-3 expande-horizontal centraliza fonte animate__fadeInLeft wrap"
                          >
                            <v-flex class="pa-3 pb-0" xs12>
                              <div class="expande-horizontal column">
                                <h2 style="color: #333;">
                                  {{ methodsConverted[this.indexByArrow] }}
                                </h2>
                                <span class="grey--text fonte">
                                  Informe o valor abaixo
                                </span>
                              </div>
                            </v-flex>
                            <v-flex class="pa-3 pt-0" xs12>
                              <div
                                class="expande-horizontal wrap"
                                style="max-height: 360px; overflow: auto; overflow-x: hidden;"
                              >
                                <div class="pb-6">
                                  <h1 style="color: #333;" class="fonte">
                                    {{
                                      $helper.formataSaldo(
                                        valueToPayInSelectedMethod || 0
                                      )
                                    }}
                                  </h1>
                                  <h3 class="grey--text">Total da compra: {{ $helper.formataSaldo(get_gestordepedido.compra.preco_total) }}</h3>
                                  <h3 class="grey--text">Total já pago: {{ $helper.formataSaldo(get_gestordepedido.compra.total_recebido) }}</h3>
                                </div>
                                <v-flex xs12>
                                  <v-text-field
                                    prefix="R$"
                                    label="Informe o valor"
                                    hint="Informe todo ou parte do valor"
                                    clearable
                                    outlined
                                    autofocus
                                    @input="formatNumberToExtense"            
                                    v-mask="[
                                      '#.##',
                                      '##.##',
                                      '###.##',
                                      '####.##',
                                      '#####.##'
                                    ]"
                                    v-model="valueToPayInSelectedMethod"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex class="pb-0" xs12>
                                  <v-text-field
                                    label="Valor por extenso"
                                    v-model="emit_receipt_form.value_extense"
                                    outlined
                                    dense
                                    hide-details
                                    :rules="[v => !!v || 'Preencha aqui']"
                                    :color="$theme.secondary"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex class="pt-2 pb-0" xs12>
                                  <v-text-field
                                    label="Referente a"
                                    v-model="emit_receipt_form.referrer_to"
                                    outlined
                                    dense
                                    hide-details
                                    :rules="[v => !!v || 'Preencha aqui']"
                                    :color="$theme.secondary"
                                  ></v-text-field>
                                </v-flex>
                              </div>
                              <div class="expande-horizontal">
                                <v-btn
                                  @click="step = 1"
                                  dark
                                  text
                                  class="fonte animate__delay-2s mr-2 animate__fadeIn grey--text text-capitalize mt-3"
                                >
                                  <v-icon size="16" class="mt-1" color="grey"
                                    >mdi-chevron-left</v-icon
                                  >
                                  voltar
                                </v-btn>
                                <v-btn
                                  @click="reportValueReceived"
                                  dark
                                  :color="$theme.third"
                                  class="fonte animate__delay-2s animate__fadeIn white--text text-capitalize mt-3"
                                >
                                  Pagar
                                </v-btn>
                                <v-spacer></v-spacer>
                              </div>
                            </v-flex>
                          </div>
                        </v-window-item>
                        <v-window-item :value="3">
                          <div
                            transition="fade"
                            v-if="loading === 'success'"
                            style="min-height: 17vh;"
                            class="mt-3 expande-horizontal centraliza fonte animate__fadeInLeft wrap"
                          >
                            <v-flex class="pa-3" xs12>
                              <div class="expande-horizontal column">
                                <h2 style="color: #1173ff;">
                                  Pagamento
                                </h2>
                                <span class="grey--text fonte">
                                  Esta compra foi integralmente paga
                                </span>
                              </div>
                            </v-flex>
                            <v-flex class="pa-3" xs12>
                              <div
                                class="expande-horizontal wrap"
                                style="max-height: 300px; overflow: auto; overflow-x: hidden;"
                              >
                                <div class="pb-6">
                                  <h1 style="color: #1173ff;" class="fonte">
                                    {{
                                      $helper.formataSaldo(
                                        get_gestordepedido.compra.total_recebido
                                      )
                                    }}
                                  </h1>
                                  <h3
                                    class="font-weight-light orange--text"
                                    v-if="get_gestordepedido.compra.troco"
                                  >
                                    troco:
                                    {{
                                      $helper.formataSaldo(
                                        get_gestordepedido.compra.troco
                                      )
                                    }}
                                  </h3>
                                </div>
                                <v-flex class="fonte" xs12>
                                  <v-list nav class="pa-0 ma-0" dense>
                                    <template
                                      v-for="(payment,
                                      i) in get_gestordepedido.historico_de_pagamento"
                                    >
                                      <v-list-item
                                        v-show="payment.valor"
                                        :key="`payment-${i}`"
                                      >
                                        <v-avatar
                                          size="30"
                                          class="mr-2"
                                          :color="$theme.third"
                                        >
                                          <span
                                            class="white--text font-weight-bold"
                                          >
                                            {{ i }}
                                          </span>
                                        </v-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title
                                            class="green--text font-weight-bold"
                                          >
                                            {{
                                              $helper.formataSaldo(
                                                payment.valor
                                              )
                                            }}
                                            em {{ payment.forma_de_pagamento }}
                                          </v-list-item-title>
                                          <v-list-item-subtitle>
                                          </v-list-item-subtitle>
                                          <v-list-item-subtitle>
                                            {{
                                              $moment(payment.data).format(
                                                "DD/MM [às] HH:mm"
                                              )
                                            }}
                                          </v-list-item-subtitle>
                                        </v-list-item-content>
                                      </v-list-item>
                                      <v-divider
                                        :key="`divider--${i}`"
                                      ></v-divider>
                                    </template>
                                  </v-list>
                                </v-flex>
                              </div>
                              <div class="expande-horizontal">
                                <v-btn
                                  @click="close"
                                  dark
                                  :color="$theme.third"
                                  class="fonte animate__delay-2s animate__fadeIn white--text text-capitalize mt-3"
                                >
                                  Fechar
                                </v-btn>
                                <v-spacer></v-spacer>
                              </div>
                            </v-flex>
                          </div>
                        </v-window-item>
                      </v-window>
                    </v-flex>
                  </div>
                </v-card>
              </div>
            </v-flex>
          </div>
        </div>
      </v-flex>
    </div>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LottieAnimation from "lottie-web-vue";
import { EventBus } from "@/main.js";
import { printReceipt } from "@/apps/shared/services/printSaleDocuments";
import {
  normalizeReceipt,
  valueToExtense
} from "@/apps/shared/services/receiptDocument";

// import ModalSendArchive from "../../shared/components/ModalSendArchive.vue";
export default {
  // components: { ModalSendArchive },
  props: {
    // updatePayment: {
    //   type: Function,
    //   default: () => {}
    // },
    payment_sys_config: {
      type: Object,
      default: () => ({
        money: { active: true },
        pix: { active: false },
        card: { active: false },
        debit: { active: false },
        custom_methods: []
      })
    },
    saveSale: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      methods: ["dinheiro"],
      methodsConverted: ["Dinheiro", "Pix", "Crédito", "Débito"],
      modal: false,
      valueToPayInSelectedMethod: "",
      loading: "",
      step: 1,
      indexByArrow: 0,
      remainingToPay: false,
      emit_receipt_form: {
        order: "",
        client: "",
        value: "",
        value_extense: "",
        referrer_to: "",
        data: ""
      },
      type: "" //payment_method_selected
    };
  },
  components: {
    LottieAnimation
  },
  computed: {
    ...mapGetters([
      "get_invoice",
      "getLoggedUser",
      "get_gestordepedido",
      "get_gestordepedidos"
    ]),
    placeholderDescription() {
      let description = "";
      if (!this.get_invoice.expense_type) {
        description = "Ex: Pagamento do Luiz...";
      }
      if (this.get_invoice.expense_type) {
        description = this.get_invoice.expense_type.description;
      }
      return description;
    },
    normalizedPaymentConfig() {
      const config = this.payment_sys_config || {};
      return {
        money: { active: true, ...(config.money || {}) },
        pix: { active: false, ...(config.pix || {}) },
        card: { active: false, ...(config.card || {}) },
        debit: { active: false, ...(config.debit || {}) },
        custom_methods: Array.isArray(config.custom_methods) ? config.custom_methods : []
      };
    },
    customPaymentMethods() {
      return this.normalizedPaymentConfig.custom_methods
        .filter(method => method && method.active !== false && method.name)
        .map(method => ({
          key: method.id,
          label: method.name,
          icon: this.paymentMethodIcon(method.type)
        }));
    }
  },
  watch: {
    "get_invoice.saved": function(val) {
      if (val) {
        this.setLoading("success");
        this.step = 4;
      }
    }
  },
  methods: {
    ...mapActions(["createGlobalMessage"]),
    buildReceiptPayload() {
      const sale = this.get_gestordepedido || {};
      const compra = sale.compra || {};
      const cliente = compra.cliente || {};
      const value =
        parseFloat(String(this.valueToPayInSelectedMethod || "0").replace(",", ".")) || 0;
      const vendedor = this.getLoggedUser || {};

      return {
        order: this.nextReceiptOrder(),
        client: this.emit_receipt_form.client || cliente.nome || "",
        value,
        value_extense: this.emit_receipt_form.value_extense || valueToExtense(value),
        referrer_to:
          this.emit_receipt_form.referrer_to ||
          `Pagamento da venda #${sale.id_transacao || ""}`.trim(),
        data: new Date().toISOString(),
        data_extense: this.$moment().format("LLLL"),
        vendedor: { _id: vendedor._id, nome: vendedor.nome }
      };
    },
    nextReceiptOrder() {
      const history = Array.isArray(this.get_gestordepedido.historico_de_pagamento)
        ? this.get_gestordepedido.historico_de_pagamento
        : [];
      return history.filter(payment => payment && payment.forma_de_pagamento !== "troco")
        .length + 1;
    },
    lastPaymentReceipt(sale = {}) {
      const history = Array.isArray(sale.historico_de_pagamento)
        ? sale.historico_de_pagamento.filter(
            payment => payment && payment.forma_de_pagamento !== "troco"
          )
        : [];
      const lastPayment = history[history.length - 1];
      if (!lastPayment) return null;
      return normalizeReceipt({
        sale,
        payment: lastPayment,
        index: history.length - 1
      });
    },
    /**
     * Imprime o recibo do pagamento informado. A impressao roda em iframe
     * (nao depende de pop-up liberado) e o HTML e montado a partir dos dados,
     * entao nao depende de nenhum node renderizado no modal.
     */
    emitReceipt(receipt, sale) {
      const saleData = sale || this.get_gestordepedido;
      const receiptData =
        receipt ||
        this.lastPaymentReceipt(saleData) ||
        normalizeReceipt({ sale: saleData, payment: { receipt: this.buildReceiptPayload() } });

      printReceipt({
        sale: saleData,
        receipt: receiptData,
        user: this.getLoggedUser,
        notify: this.createGlobalMessage,
        context: { vuetify: this.$vuetify }
      });

      this.valueToPayInSelectedMethod = "";
      this.type = "";
      this.saveSale();
      this.close();
    },
    formatNumberToExtense() {
      // const value = this.emit_receipt_form.value || "0";
      const value = this.valueToPayInSelectedMethod || "0";
      this.emit_receipt_form.value_extense = valueToExtense(value);
      this.emit_receipt_form.value = value;
      this.$forceUpdate();
    },
    paymentMethodIcon(type) {
      if (type === "card_machine") return "mdi-credit-card-wireless-outline";
      if (type === "credit") return "mdi-account-clock-outline";
      return "mdi-wallet-outline";
    },
    getPaymentMethodLabel(method) {
      if (method && typeof method === "object") return method.label;
      const labels = {
        dinheiro: "Dinheiro",
        pix: "Pix",
        credito: "Credito",
        debito: "Debito"
      };
      return labels[method] || method;
    },
    getPaymentMethodByIndex(index) {
      if (index < this.methods.length) return this.methods[index];
      return this.customPaymentMethods[index - this.methods.length];
    },
    selectPaymentMethod(method) {
      const paymentMethod = method && typeof method === "object"
        ? method
        : { key: method, label: this.getPaymentMethodLabel(method) };
      const methodIndex = this.methods.indexOf(paymentMethod.key);
      this.indexByArrow = methodIndex >= 0
        ? methodIndex
        : this.methods.length + this.customPaymentMethods.findIndex(customMethod => customMethod.key === paymentMethod.key);
      this.type = paymentMethod.key;
      this.get_gestordepedido.compra.payment_method_selected = {
        key: paymentMethod.key,
        label: paymentMethod.label
      };
      this.methodsConverted[this.indexByArrow] = paymentMethod.label;
      let remainingToPay = 0;
      // valor que ainda falta para pagar
      if (this.valueToPayInSelectedMethod > 0) {
        this.get_gestordepedido.compra[this.type] = parseFloat(
          this.valueToPayInSelectedMethod
        ).toFixed(2);
      }
      if (this.get_gestordepedido.compra[this.type]) {
        if (this.get_gestordepedido.compra[this.type] > 0) {
          this.get_gestordepedido.compra.total_recebido =
            this.get_gestordepedido.compra.total_recebido -
            parseFloat(this.get_gestordepedido.compra[this.type]);
        }
      }
      remainingToPay =
        parseFloat(this.get_gestordepedido.compra.preco_total) -
        (this.get_gestordepedido.compra.total_recebido || 0);

      if (remainingToPay === 0) {
        this.step = 3;
      } else {
        this.valueToPayInSelectedMethod = remainingToPay.toFixed(2);
        this.step = 2;
        this.formatNumberToExtense();
      }
    },
    reportValueReceived() {
      if (this.valueToPayInSelectedMethod > 0) {
        this.get_gestordepedido.compra[this.type] = parseFloat(
          this.valueToPayInSelectedMethod
        ).toFixed(2);
        this.get_gestordepedido.compra.custom_payment_value = parseFloat(
          this.valueToPayInSelectedMethod
        ).toFixed(2);
        this.pay();
      }
    },
    pay() {
      this.updatePayment();
      // this.open();
    },
    updatePayment() {
      const receipt = this.buildReceiptPayload();
      this.$store.dispatch("enableLoading");
      this.$run("caixas/update-payment", { ...this.get_gestordepedido, receipt })
        .then(res => {
          this.$store.dispatch("disableLoading");
          const sale = res.data;
          this.$store.commit("set_gestordepedido", sale);
          const docs = this.get_gestordepedidos.docs || [];
          const newDocs = docs.map(docTransaction =>
            docTransaction._id === sale._id ? sale : docTransaction
          );
          this.$store.commit("set_gestordepedidos", {
            ...this.get_gestordepedidos,
            docs: newDocs
          });
          if (sale.status_do_pagamento === "pago") {
            this.step = 3;
            this.setLoading("success");
          } else {
            this.step = 1;
          }
          this.$forceUpdate();
          this.emitReceipt(this.lastPaymentReceipt(sale) || receipt, sale);
        })
        .catch(e => {
          this.$store.dispatch("disableLoading");
          this.createGlobalMessage({
            type: "error",
            message:
              (e.response && e.response.data && e.response.data.message) ||
              "Nao foi possivel registrar o pagamento.",
            timeout: 6000
          });
        });
    },
    setLoading(state) {
      this.loading = "";
      setTimeout(() => {
        this.loading = state;
      }, 300);
    },
    open() {
      this.modal = false;
      this.modal = true;

      if (this.get_gestordepedido.status_do_pagamento === "pago") {
        this.setLoading("success");
        this.step = 3;
      } else {
        const cliente =
          (this.get_gestordepedido.compra && this.get_gestordepedido.compra.cliente) || {};
        // todas as chaves precisam existir para o v-model dos campos do recibo ser reativo
        this.emit_receipt_form = {
          order: "",
          client: cliente.nome || "",
          value: "",
          value_extense: "",
          referrer_to: `Pagamento da venda #${this.get_gestordepedido.id_transacao || ""}`.trim(),
          data: "",
          vendedor: this.getLoggedUser
        };
        setTimeout(() => {
          this.setLoading("man_typing");
          this.step = 1;
        }, 100);
      }
    },
    close() {
      this.modal = false;
    },
    stepBack() {
      if (this.step === 1) {
        this.close();
      } else {
        this.step--;
      }
    }
  },
  mounted() {
    EventBus.$on("ArrowUp", () => {
      if (this.indexByArrow > 0) {
        this.indexByArrow--;
      }
    });
    EventBus.$on("ArrowDown", () => {
      if (this.indexByArrow < this.methods.length + this.customPaymentMethods.length - 1) {
        this.indexByArrow++;
      }
    });
    EventBus.$on("ArrowLeft", () => {
      this.stepBack();
    });
    EventBus.$on("ArrowRight", () => {
      if (this.step === 1) {
        this.selectPaymentMethod(this.getPaymentMethodByIndex(this.indexByArrow));
      }
    });
    EventBus.$on("Enter", () => {
      if (this.step === 1) {
        this.selectPaymentMethod(this.getPaymentMethodByIndex(this.indexByArrow));
      }
    });
  }
};
</script>

<style>
.paymentMethodPreSelected {
  background: #1173ff !important;
  border-radius: 6px;
}

.paymentMethodPreSelected .v-list-item__subtitle,
.paymentMethodPreSelected .font-default-color,
.paymentMethodPreSelected .v-icon {
  color: #ffffff !important;
}
</style>
